import React, { Component } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import { Link } from "react-router-dom";

import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import {
  addPlan,
  deletePlan,
  getPlanFilterData,
  getPlansList,
  updatePlanProfile,
  getPlansProfit,
  deletePlansBulk,
  getPlanGroups,
  deletePlanGroups,
  updatePlanGroup,
  addPlanGroup,
  // getPayoutConditions,
  deletePayoutCondition,
  updatePayoutCondition,
  addPayoutCondition,
  OverviewAddNewRow,
  RemoveOverviewRow,
  AddCustomProfit,
  DeleteCustomProfit,
  editCustomProfit,
  closeEditCustomProfit,
  updateCustomProfit,
  getCustomProfitByDays,
  setCustomProfitByDays,
  updateCustomProfitByDays,
  addCustomProfitByDays,
  setPlansList
} from "../../../store/plans/actions";

import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import queryString from "query-string";
import PlansOverview from "./components/PlansOverview";
import PlansList from "./components/PlansList";
import PlanListBreadcrumb from "./components/common/PlanListBreadcrumb";
import PlansPayouts from "./components/PlansPayouts";
import PlanOverviewBreadcrumb from "./components/common/PlanOverviewBreadcrumb";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';
import {
  getSelectedMonthAgoWithFirstDay,
  getSelectedMonthAgoWithLastDay,
} from "../../../helpers/utils";
import ProjectProfitWidgets from "./components/common/ProjectProfitWidgets";

class Plans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "overview",
      nesting: false,
      nestingTable: false,
      selectedGroup: null,
      selectedGroupTable: null,
      isAdmin: false,
      positions: {},
    };
  }

  componentDidMount() {
    const { permissions } = this.props;
    let date = this.props.profitFilterData;
    const location = this.props.history.location;
    let parsedSearch = queryString.parse(location.search);
    date["start_date"] =
      parsedSearch.start_date || getSelectedMonthAgoWithFirstDay(0);
    date["end_date"] =
      parsedSearch.end_date || getSelectedMonthAgoWithLastDay(-1);

    const hash = this.props.location.hash.split("#").join("") || "overview";

    let params = {
      admin: this.props.user?.positions.includes(33),
      headAM: this.props.user?.positions.includes(43),
      accountManager: this.props.user?.positions.includes(7),
      middleAM: this.props.user?.positions.includes(52),
      teamLeadMB: this.props.user?.positions.includes(53),
      headMB: this.props.user?.positions.includes(42),
      mediaBuyer: this.props.user?.positions.includes(6),
    };

    this.setState({
      positions: params,
    });

    if (
      permissions["is_head_of_accountmanager"] ||
      permissions["is_admin"] ||
      permissions["is_viewer"] ||
      permissions["is_hr"] ||
      permissions["is_accountmanager"]
    ) {
      this.props.getPlansProfit({
        date_from: date.start_date,
        date_to: date.end_date,
        ...(!permissions["is_admin"] && permissions["is_accountmanager"] && { for_yourself: true })
      });
      this.setState({ isAdmin: true });

      // this.props.getPayoutConditions({
      //   ...this.props.payoutData,
      // });

      this.props.getPlanFilterData();
      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: date.start_date,
          end_date: date.end_date,
        })
      );

      location.search = formQueryString;
      location.hash = hash;
    } else {
      this.props.getPlansProfit({
        date_from: date.start_date,
        date_to: date.end_date,
        for_yourself: true,
      });
    }

    this.props.history.replace(location);
    this.toggle(hash);
  }

  componentDidUpdate(prevProps, prevState) {
    let parsedSearch = queryString.parse(this.props.history.location.search);
    if (prevProps.location.hash !== this.props.location.hash) {
      this.handleUpdateTab();
    }
    if (
      prevProps.planGroups !== this.props.planGroups &&
      this.props.planGroups.results.length > 0 &&
      parsedSearch?.group
    ) {
      let idx = this.props.planGroups.results.findIndex(
        i => i.id == parsedSearch.group
      );
      let selectedData = {
        id: parsedSearch.group,
        name: this.props.planGroups.results[idx]?.name,
      };
      this.handleChangeNesting(true, selectedData);
      this.setState({
        selectedGroup: selectedData?.name,
      });
    }
  }

  handleUpdateTab = () => {
    const hash = this.props.location.hash.split("#").join("") || "overview";
    this.toggle(hash);
  };

  handleDateRangeChange = (data = "overview", type) => {
    const prevSearch = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, data)
    );

    let params = {
      date_from: data.start_date,
      date_to: data.end_date,
    };

    if (this.state.nestingTable)
      params["group_name"] = this.state.selectedGroupTable;

    if (
      this.props.permissions["is_head_of_accountmanager"] || this.props.permissions["is_admin"] || this.props.permissions["is_viewer"] || this.props.permissions["is_hr"]
    ) {
      this.props.getPlansProfit({
        ...params,
        ...(!this.props.permissions["is_admin"] && this.props.permissions["is_accountmanager"] && { for_yourself: true })
      });
    } else {
      this.props.getPlansProfit({
        ...params,
        for_yourself: true,
      });
    }

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
  };

  handleTableChange = (data, type) => {
    let params = {
      date_from: this.props.profitFilterData.start_date,
      date_to: this.props.profitFilterData.end_date,
      ordering: data.ordering,
    };

    if (this.state.nestingTable)
      params["group_name"] = this.state.selectedGroupTable;

    if (
      this.props.permissions["is_head_of_accountmanager"] || this.props.permissions["is_admin"] || this.props.permissions["is_viewer"] || this.props.permissions["is_hr"]
    ) {
      this.props.getPlansProfit({
        ...params,
        ...(!this.props.permissions["is_admin"] && this.props.permissions["is_accountmanager"] && { for_yourself: true })
      });
    } else {
      this.props.getPlansProfit({
        ...params,
        for_yourself: true,
      });
    }
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddBudgetModal = () => {
    this.setState(prevState => ({
      viewAddBudget: !prevState.viewAddBudget,
    }));
  };

  onClickRow = item => {
    if ("offer" in this.getQuery()) return void 0;
  };

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  handleChangeNestingTable = (status, data, id) => {
    let date = this.props.profitFilterData;
    let parsedSearch = queryString.parse(this.props.history.location.search);
    date["start_date"] = parsedSearch.start_date || date.start_date;
    date["end_date"] = parsedSearch.end_date || date.end_date;

    if (!status) {
      this.props.getPlansProfit({
        date_from: date.start_date,
        date_to: date.end_date,
        ...(!this.props.permissions["is_admin"] && this.props.permissions["is_accountmanager"] && { for_yourself: true })
      });
      this.setState({
        nestingTable: false,
        selectedGroupTable: null,
      });
    } else {
      this.props.getPlansProfit({
        date_from: date.start_date,
        date_to: date.end_date,
        group_name: data?.name,
        // ...(this.props.permissions["is_accountmanager"] && { for_yourself: true })
      });
      this.setState({
        nestingTable: true,
        selectedGroupTable: data?.name,
      });
    }
  };

  handleChangeNesting = (status, data, id) => {
    let date = this.props.profitFilterData;
    let parsedSearch = queryString.parse(this.props.history.location.search);
    date["start_date"] = parsedSearch.start_date || date.start_date;
    date["end_date"] = parsedSearch.end_date || date.end_date;

    if (!status) {
      if (parsedSearch?.group) delete parsedSearch.group;
      let formQueryString = queryString.stringify(Object.assign(parsedSearch));
      this.props.history.push({
        ...this.props.history.location,
        search: formQueryString,
      });
      this.props.getPlanGroups({
        page: parsedSearch.page || 1,
        size: parsedSearch.size || 10,
        date_from_gte: date.start_date,
        date_to_lte: date.end_date,
      });
      this.setState({
        nesting: false,
        selectedGroup: null,
      });
    } else {
      this.props.getPlansList({
        ...this.props.planListData,
        group: data?.id || id,
        offer_id: parsedSearch.account_manager
          ? parsedSearch.account_manager
          : [],
        account_manager: parsedSearch.account_manager
          ? parsedSearch.account_manager
          : [],
      });

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          group: data?.id || id,
        })
      );

      this.props.history.push({
        ...this.props.history.location,
        search: formQueryString,
      });

      this.setState({
        nesting: true,
        selectedGroup: data.name,
      });
    }
  };

  render() {
    const { permissions } = this.props;
    const checkPerm = () => {
      const { positions } = this.state;
      if (positions.admin || positions.headAM || positions.middleAM) {
        return true;
      } else if (positions.accountManager) {
        return false;
      }
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title="Plans | Mobihunter" />
          <Container fluid>
            <Breadcrumbs
              title="Dashboard"
              breadcrumbItem="Plans"
              link="/dashboard"
            />
            <Row>
              <Col sm="col-12">
                <Card className="mb-0">
                  <CardBody>
                    <Nav
                      tabs
                      className="nav-tabs-custom"
                      style={{
                        width: "80%",
                        borderBottom: "0",
                      }}
                    >
                      <NavItem>
                        <Link
                          style={{ cursor: "pointer" }}
                          to={{
                            hash: "overview",
                            search: this.props.location.search,
                          }}
                          className={classnames("nav-link", {
                            active: this.state.activeTab === "overview",
                          })}
                          onClick={() => {
                            this.toggle("overview");
                          }}
                        >
                          Overview
                        </Link>
                      </NavItem>
                      {(permissions["is_head_of_accountmanager"] ||
                        permissions["is_admin"] ||
                        permissions["is_accountmanager"] ||
                        permissions["is_viewer"]) && (
                          <>
                            <NavItem>
                              <Link
                                style={{ cursor: "pointer" }}
                                to={{
                                  hash: "plans",
                                  search: this.props.location.search,
                                }}
                                className={classnames("nav-link", {
                                  active: this.state.activeTab === "plans",
                                })}
                                onClick={() => {
                                  this.toggle("plans");
                                }}
                              >
                                Plans
                              </Link>
                            </NavItem>
                            {/* <NavItem>
                              <Link
                                style={{ cursor: "pointer" }}
                                to={{
                                  hash: "payout-condition",
                                  search: this.props.location.search,
                                }}
                                className={classnames("nav-link", {
                                  active:
                                    this.state.activeTab === "payout-condition",
                                })}
                                onClick={() => {
                                  this.toggle("payout-condition");
                                }}
                              >
                                Payout conditions
                              </Link>
                            </NavItem> */}
                          </>
                        )}
                    </Nav>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>

          <TabContent
            activeTab={this.state.activeTab}
            className="text-muted"
            style={{ padding: "40px 12px 0px 12px" }}
          >
            <TabPane tabId="overview">
              <Row>
                <Col className="col-12">
                  <ProjectProfitWidgets plan={this.props.profitPlansData.widget?.total_plan || 0}
                    total_profit={this.props.profitPlansData.widget?.total_profit || 0}
                    percent={this.props.profitPlansData.widget?.total_percent || 0} />
                  <Card>
                    <CardBody style={{ paddingTop: "12px" }}>
                      <PlansOverview
                        planStatus={this.props.statusPlansProfit}
                        selectedGroupTable={this.state.selectedGroupTable}
                        data={this.props.profitPlansData}
                        loading={this.props.profitPlansLoader}
                        handleDateRangeChange={this.handleDateRangeChange}
                        profitFilterData={this.props.profitFilterData}
                        filter_data={this.props.filter_data}
                        history={this.props.history}
                        handleChangeNestingTable={this.handleChangeNestingTable}
                        nesting={this.state.nestingTable}
                        OverviewAddNewRow={this.props.OverviewAddNewRow}
                        RemoveOverviewRow={this.props.RemoveOverviewRow}
                        AddCustomProfit={this.props.AddCustomProfit}
                        DeleteCustomProfit={this.props.DeleteCustomProfit}
                        editCustomProfit={this.props.editCustomProfit}
                        closeEditCustomProfit={this.props.closeEditCustomProfit}
                        updateCustomProfit={this.props.updateCustomProfit}
                        updatePlanGroup={this.props.updatePlanGroup}
                        customProfitByDayData={this.props.customProfitByDayData}
                        getCustomProfitByDays={this.props.getCustomProfitByDays}
                        customProfitByDayLoader={
                          this.props.customProfitByDayLoader
                        }
                        setCustomProfitByDays={this.props.setCustomProfitByDays}
                        updateCustomProfitByDays={
                          this.props.updateCustomProfitByDays
                        }
                        addCustomProfitByDays={this.props.addCustomProfitByDays}
                        permissions={this.props.permissions}
                        handleTableChange={this.handleTableChange}
                        canEditPlan={false}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </TabPane>
            {(permissions["is_head_of_accountmanager"] || permissions["is_accountmanager"] || permissions["is_admin"] || permissions["is_viewer"]) && (
              <>
                <TabPane tabId="plans">
                  <Row>
                    <Col className="col-12">
                      <Card>
                        <CardBody>
                          <PlansList
                            selectedGroup={this.state.selectedGroup}
                            getPlanGroups={this.props.getPlanGroups}
                            group_loader={this.props.group_loader}
                            groups={this.props.planGroups}
                            nesting={this.state.nesting}
                            deletePlanGroups={this.props.deletePlanGroups}
                            updatePlanGroup={this.props.updatePlanGroup}
                            addPlanGroup={this.props.addPlanGroup}
                            changeNesting={this.handleChangeNesting}
                            getPlansList={this.props.getPlansList}
                            setPlansList={this.props.setPlansList}
                            handleDateRangeChange={this.handleDateRangeChange}
                            addPlan={this.props.addPlan}
                            updatePlanProfile={this.props.updatePlanProfile}
                            deletePlan={this.props.deletePlan}
                            getPlanFilterData={this.props.getPlanFilterData}
                            data={this.props.planListData}
                            loading={this.props.planListLoading}
                            history={this.props.history}
                            permissions={this.props.permissions}
                            filter_data={this.props.filter_data}
                            users_list={this.props.users_list}
                            profitFilterData={this.props.profitFilterData}
                            planListData={this.props.planListData}
                            deletePlansBulk={this.props.deletePlansBulk}
                            getPlansProfit={this.props.getPlansProfit}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane>
                {/* <TabPane tabId="payout-condition">
                  <Row>
                    <Col className="col-12">
                      <Card>
                        <CardBody>
                          <PlansPayouts
                            data={this.props.payoutData}
                            loader={this.props.payout_loader}
                            getPayoutConditions={this.props.getPayoutConditions}
                            deletePayoutCondition={
                              this.props.deletePayoutCondition
                            }
                            updatePayoutCondition={
                              this.props.updatePayoutCondition
                            }
                            addPayoutCondition={this.props.addPayoutCondition}
                            history={this.props.history}
                            permissions={this.props.permissions}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </TabPane> */}
              </>
            )}
          </TabContent>
        </div>
      </React.Fragment>
    );
  }
}

Plans.propTypes = {
  history: PropTypes.object.isRequired,
  permissions: PropTypes.object.isRequired,
  profitFilterData: PropTypes.object.isRequired,
  filter_data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  users_list: PropTypes.object.isRequired,
  profitPlansData: PropTypes.object.isRequired,
  planListData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  customProfitByDayData: PropTypes.array.isRequired,
  customProfitByDayLoader: PropTypes.bool,
  planGroups: PropTypes.any,
  group_loader: PropTypes.bool.isRequired,
  profitPlansLoader: PropTypes.bool.isRequired,
  planListLoading: PropTypes.bool.isRequired,
  payoutData: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  payout_loader: PropTypes.bool,
  getPlanFilterData: PropTypes.func.isRequired,
  updatePlanProfile: PropTypes.func.isRequired,
  getPlansProfit: PropTypes.func.isRequired,
  getPlansList: PropTypes.func.isRequired,
  addPlan: PropTypes.func.isRequired,
  deletePlan: PropTypes.func.isRequired,
  deletePlansBulk: PropTypes.func.isRequired,
  getPlanGroups: PropTypes.func.isRequired,
  deletePlanGroups: PropTypes.func.isRequired,
  updatePlanGroup: PropTypes.func.isRequired,
  addPlanGroup: PropTypes.func.isRequired,
  // getPayoutConditions: PropTypes.func.isRequired,
  deletePayoutCondition: PropTypes.func.isRequired,
  updatePayoutCondition: PropTypes.func.isRequired,
  addPayoutCondition: PropTypes.func.isRequired,
  OverviewAddNewRow: PropTypes.func.isRequired,
  RemoveOverviewRow: PropTypes.func.isRequired,
  AddCustomProfit: PropTypes.func.isRequired,
  DeleteCustomProfit: PropTypes.func.isRequired,
  editCustomProfit: PropTypes.func.isRequired,
  closeEditCustomProfit: PropTypes.func.isRequired,
  updateCustomProfit: PropTypes.func.isRequired,
  getCustomProfitByDays: PropTypes.func.isRequired,
  setCustomProfitByDays: PropTypes.func.isRequired,
  updateCustomProfitByDays: PropTypes.func.isRequired,
  addCustomProfitByDays: PropTypes.func.isRequired,
  setPlansList: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  statusPlansProfit: PropTypes.any,
};

const mapStateToProps = state => ({
  planGroups: state.PlanList.groups,
  planListData: state.PlanList.data,
  group_loader: state.PlanList.group_loader,
  planListLoading: state.PlanList.loading,
  payoutData: state.PlanList.payoutData,
  payout_loader: state.PlanList.payout_loader,
  permissions: state.User.permissions,
  filter_data: state.PlanList.filter_data,
  users_list: state.PlanList.users_list,
  profitFilterData: state.PlanList.profitFilterData,
  profitPlansData: state.PlanList.profit_plans,
  profitPlansLoader: state.PlanList.profit_plans_loader,
  customProfitByDayData: state.PlanList.customProfitByDays,
  customProfitByDayLoader: state.PlanList.customProfitByDaysLoader,
  statusPlansProfit: state.PlanList.statusPlansProfit,
  user: state.User.user_settings,
});

export default connect(mapStateToProps, {
  getPlansList,
  setPlansList,
  addPlan,
  updatePlanProfile,
  deletePlan,
  getPlanFilterData,
  getPlansProfit,
  deletePlansBulk,
  getPlanGroups,
  deletePlanGroups,
  updatePlanGroup,
  addPlanGroup,
  // getPayoutConditions,
  deletePayoutCondition,
  updatePayoutCondition,
  addPayoutCondition,
  OverviewAddNewRow,
  RemoveOverviewRow,
  AddCustomProfit,
  DeleteCustomProfit,
  editCustomProfit,
  closeEditCustomProfit,
  updateCustomProfit,
  getCustomProfitByDays,
  setCustomProfitByDays,
  updateCustomProfitByDays,
  addCustomProfitByDays,
})(Plans);
